import Delegate from "ftdomdelegate";
import { add, qs, qsa, remove } from "@fluorescent/dom";

import { cart } from "@/glow";
import { on } from "@/glow/events";

const selectors = {
  cartQuantityCountDisplay: id => `.quantity-in-cart-display[data-id="${id}"]`,
  filtersHeading: "[data-filter-expand]",
  filterReset: "[data-filter-reset]",
  filterValues: "[data-filter-values]",
  filterValue: "[data-filter-value]",
  filterValueInput: "[data-filter-value-input]",
  item: "[data-input-item]",
  itemError: ".quick-add__item-error",
  itemProperties: "[data-item-properties]",
  quickAddWrapper: ".product-item__quick-add-wrapper",
  modalContent: ".modal__content",
  modalContentInner: ".quick-add-modal__content",
  modalFooter: ".quick-add-modal__footer",
  productQuantityInput: "[data-product-quantity-input]",
  quantityInput: "[data-quantity-input]",
  quantityAdd: "[data-add-quantity]",
  quantitySubtract: "[data-subtract-quantity]",
  quantityWrapper: ".quantity-input",
  variantRow: "[data-item-type='variant']",
  variantRowById: id => `[data-item-type='variant'][data-variant-id='${id}']`,
  removeItem: "[data-remove-item]",
  variant: "[data-item-type='variant']",
  elsWithDataQuantityInCart: "[data-quantity-in-cart]",
  iconStyleProductItemQuantity:
    '[data-quick-add-style="icon"] .quantity-input-wrapper--product-item-quick-add',
};

const classes = {
  active: "active",
  hidden: "visually-hidden",
  updatingQuantity: "pending-quantity-update",
  iconStyleProductItemQuantityPendingCollapse: "pending-collapse",
  noQuantity: "no-quantity-in-cart",
};

// Removing until quick add modal can be fleshed out.
/*function initQuickAddFilters() {
  const delegate = new Delegate(document);

  delegate.on("click", selectors.filterValueInput, (_, target) => {
    add(target.closest(selectors.filterValues), classes.active);
    add(target.parentElement, classes.active);
    _handleFilterVariants(target.closest(selectors.modalContentInner));
  });

  delegate.on("click", selectors.filterReset, (_, target) => {
    const checkedFilter = qs("input:checked", target.parentElement);
    checkedFilter && (checkedFilter.checked = false);
    remove(target.closest(selectors.filterValues), classes.active);
    remove(checkedFilter.parentElement, classes.active);
    _handleFilterVariants(target.closest(selectors.modalContentInner));
  });

  delegate.on("click", selectors.filtersHeading, (_, target) => {
    target.dataset.filterExpand === "false"
      ? (target.dataset.filterExpand = "true")
      : (target.dataset.filterExpand = "false");
  });

  const unload = () => {
    delegate.off();
  };

  return {
    unload,
  };
}*/

// Removing until quick add modal can be fleshed out.
/*function initQuickAddModalCounts() {
  const modalContent = qs(selectors.modalContent, document);
  const events = [
    on(
      "theme-internal:update-product-item-modal-counts",
      ({ variantId, variantQuantity }) =>
        updateModalVariantsCounts(variantId, variantQuantity, modalContent)
    ),
    on("theme-internal:update-product-item-counts", ({ id, quantity }) => {
      const cartQuantityCountDisplayEls = qsa(
        selectors.cartQuantityCountDisplay(id),
        modalContent
      );

      cartQuantityCountDisplayEls.forEach(el => {
        el.textContent = quantity;
      });
    }),
  ];

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return {
    unload,
  };
}*/

// Removing until quick add modal can be fleshed out.
/*function initQuickAddModalFooter(node) {
  const quickAddFooter = qs(selectors.modalFooter, node);
  let lastVariant = qs(`${selectors.variant}:last-of-type`, node);

  const observer = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (visible) {
        remove(quickAddFooter, classes.active);

        observer.disconnect();
      }
    },
    { threshold: 0.1 }
  );

  remove(quickAddFooter, classes.hidden);
  add(quickAddFooter, classes.active);
  observer.observe(lastVariant);

  on("theme-internal:quick-add-filters-updated", () => {
    const visibleVariants = qsa(
      `${selectors.variant}:not(.visually-hidden)`,
      node
    );

    observer.disconnect();
    add(quickAddFooter, classes.active);
    lastVariant = visibleVariants[visibleVariants.length - 1];
    observer.observe(lastVariant);
  });

  const unload = () => {
    observer?.disconnect();
  };

  return {
    unload,
  };
}*/

function initQuickAddQuantitySelectors(node) {
  const delegate = new Delegate(node);

  delegate.on("click", selectors.quantitySubtract, (_, target) => {
    const { variantId, qty } = _getItemData(target);
    const newQuantity = qty - 1;

    cart.updateItem(variantId, newQuantity);
  });

  delegate.on("click", selectors.quantityAdd, (_, target) => {
    const { variantId } = _getItemData(target);

    cart.addItemById(variantId, 1);
  });

  delegate.on("change", selectors.quantityInput, (_, target) => {
    const { variantId } = _getItemData(target);

    cart.updateItem(variantId, parseInt(target.value, 10));
    add(target.closest(selectors.quantityWrapper), classes.updatingQuantity);
  });

  delegate.on("click", selectors.removeItem, (_, target) => {
    const { variantId, qty } = _getItemData(target);

    if (qty > 0) {
      cart.updateItem(variantId, 0);
      add(target.closest(selectors.quantityWrapper), classes.updatingQuantity);
    }
  });

  delegate.on(
    "click",
    [selectors.quantitySubtract, selectors.quantityAdd],
    (_, target) => {
      add(target.closest(selectors.quantityWrapper), classes.updatingQuantity);
    }
  );

  const events = [
    on("quick-add:error", (_, { id, errorMessage }) => {
      const item = node.closest(selectors.item);

      if (item.dataset.variantId === id) {
        console.log(errorMessage);
        _handleErrorMessage(item);
      }
    }),
  ];

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
    delegate.off();
  };

  return {
    unload,
  };
}

function initQuickAddTemplateCounters(node) {
  const events = [
    on("theme-internal:update-product-item-counts", ({ id, quantity }) => {
      const item = node.closest(selectors.item);

      if (parseInt(item.dataset.id, 10) === id) {
        _handleUpdateProductCount(item, quantity);
      }
    }),
    // Removing until quick add modal can be fleshed out.
    /* on(
      "theme-internal:update-product-item-modal-counts",
      ({ variantId, variantQuantity }) => {
        const modalTemplate = qs("template", node)?.content;
        modalTemplate &&
          updateModalVariantsCounts(variantId, variantQuantity, modalTemplate);
      }
    ), */
  ];

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return {
    unload,
  };
}

// Removing until quick add modal can be fleshed out.
/* function updateModalVariantsCounts(variantId, variantQuantity, content) {
  const quickAddVariantRows = qsa(selectors.variantRow, content);

  quickAddVariantRows.forEach(variantRow => {
    if (parseInt(variantRow.dataset.variantId, 10) === variantId) {
      // TODO: Widgets should self update (listen to events?) perhaps once webcomponents

      // Update any widget's inputs
      const quantityInputs = qsa(selectors.quantityInput, variantRow);
      quantityInputs.forEach(input => {
        input.value = variantQuantity;
      });

      // Update any widget's non-input display
      const elsWithDataQuantityInCart = qsa(selectors.elsWithDataQuantityInCart, variantRow);
      elsWithDataQuantityInCart.forEach(el => {
        el.dataset.quantityInCart = variantQuantity;
      });

      qs(selectors.quantityInput, variantRow).value = variantQuantity;
      const countDisplayEl = qs(
        selectors.cartQuantityCountDisplay(variantId),
        variantRow
      );

      if (countDisplayEl) {
        countDisplayEl.textContent = variantQuantity;
      }

      variantRow.dataset.quantityInCart = variantQuantity;

      remove(
        qs(selectors.quantityWrapper, variantRow),
        classes.updatingQuantity
      );
    }
  });
}
*/

// Removing until quick add modal can be fleshed out.
/* function _handleFilterVariants(node) {
  const variants = qsa(selectors.variant, node);
  const filtersHeading = qs(selectors.filtersHeading, node);
  const checkedFilterValues = qsa("input:checked", node).map(
    filter => filter.value
  );

  filtersHeading.dataset.filtersActive = checkedFilterValues.length > 0;

  variants.forEach(variant => {
    if (checkedFilterValues.every(filter => variant.id.includes(filter))) {
      remove(variant, classes.hidden);
    } else {
      add(variant, classes.hidden);
    }
  });

  emit("theme-internal:quick-add-filters-updated");
}*/

function _getItemData(target) {
  const item = target.closest(selectors.item);
  const { id, variantId } = item.dataset;
  const qty = parseInt(qs(selectors.quantityInput, item).value);

  return { item, id, variantId, qty };
}

function _handleUpdateProductCount(item, newQuantity) {
  const productId = item.dataset.id;
  item.dataset.quantityInCart = newQuantity;

  const elsWithDataQuantityInCart = qsa(
    selectors.elsWithDataQuantityInCart,
    item
  );

  elsWithDataQuantityInCart.forEach(el => {
    el.dataset.quantityInCart = newQuantity;
  });

  remove(qsa(selectors.quantityWrapper, item), classes.updatingQuantity);

  const productQuantityInputs = qsa(selectors.productQuantityInput, item);

  productQuantityInputs.forEach(input => {
    input.value = newQuantity;
  });

  if (newQuantity === 0) {
    const quickAddWrapper = qs(selectors.quickAddWrapper, item);
    remove(quickAddWrapper, classes.active);
  }

  const cartDisplayEls = qsa(
    selectors.cartQuantityCountDisplay(productId),
    item
  );

  // TODO: not sure we should be updating the template here...
  // Removing until quick add modal can be fleshed out.
  /* const modalTemplate = qs("template", item)?.content;

  if (
    modalTemplate &&
    qs(selectors.cartQuantityCountDisplay(productId), modalTemplate)
  ) {
    cartDisplayEls.push(
      qs(selectors.cartQuantityCountDisplay(productId), modalTemplate)
    );
  }*/

  cartDisplayEls.forEach(el => {
    el.textContent = newQuantity;
  });
}

function _handleErrorMessage(item) {
  const itemEl = qs(selectors.quantityWrapper, item);
  const itemElInput = qs("input", itemEl);
  const cartQuantity = itemEl.closest(selectors.elsWithDataQuantityInCart)
    .dataset.quantityInCart;

  itemElInput.value = cartQuantity;
  remove(itemEl, classes.updatingQuantity);
}

export {
  initQuickAddTemplateCounters,
  // initQuickAddFilters, /* Removing until quick add modal can be fleshed out. */
  // initQuickAddModalCounts, /* Removing until quick add modal can be fleshed out. */
  // initQuickAddModalFooter, /* Removing until quick add modal can be fleshed out. */
  initQuickAddQuantitySelectors,
  // updateModalVariantsCounts, /* Removing until quick add modal can be fleshed out. */
};
